module.exports = __webpack_public_path__ + "static/media/covid-19_Ghana_June_2021.93c1c31e.pdf";